export default __webpack_public_path__ + "static/milkrun-cdff13393d6bccea5096e6e4efd7cb6a.png";